export const ERROR_CODE = [
    'MaximumLineExceededException',
    'MaximumSizeExceededException',
    'FileNotFoundException',
]